import './style.scss'
import { Media } from '../../../js/utils/const'
import { showContactsMobileModal } from '../../popups/v1/ContactsMobileModal/scripts'

export default !function () {
  const block = document.querySelector('.price-v11')

  if (!block) {
    return
  }

  const blockName = block.dataset.blockName || 'Блок без названия'
  const helpPhoneLink = block.querySelector('.price-v11__help-phone')
  const priceInfo = block.querySelector('.price-v11__price-info')
  const form = block.querySelector('.form')

  if (!form) {
    const error = new Error(`[PriceV11]: .form not found`)
    window.Sentry?.captureException(error)
    return
  }

  const submitButtonDesktop = form.querySelector('.ui-button[type=submit].price-v11__button--desktop')
  const submitButtonMobile = form.querySelectorAll('.ui-button[type=button].price-v11__button--mobile')
  const methodsWrapper = form.querySelector('.price-v11__methods')
  const contactsInputs = form.querySelectorAll('.price-v11__contacts input')
  const promoAccepted = form.querySelector('.ui-checkbox-field__input[name="promo_accepted"]')
  const priceList = priceInfo?.querySelector('.price-v11__price-list')
  const priceValueEl = priceInfo?.querySelector('.price-v11__price-value')
  const priceValue =  priceValueEl?.querySelector('strong')
  const priceDescriptions = priceInfo?.querySelector('.price-v11__price-descriptions')

  const methods = block.dataset.payments ? JSON.parse(block.dataset.payments) : null
  const nomenclatureId = block.dataset.nomenclatureId ? block.dataset.nomenclatureId : null

  let isDesktop = false

  if (!methods || methods?.length === 0) {
    const error = new Error(`[PriceV11]: methods is required - ${methods}`)
    window.Sentry?.captureException(error)
    return
  }

  const findMethod = (value) => methods.find(m => m.value === value)

  const setPriceInfo = (method) => {
    if (!priceList || !priceValue) return

    if (!method) {
      priceInfo.hidden = true
      priceList.innerHTML = ''
      priceValueEl.hidden = true
      priceValue.textContent = ''
      if (priceDescriptions) priceDescriptions.innerHTML = ''

      return
    }

    if (method.details?.length) {
      const firstIsOld = method.details.length > 1
      priceList.innerHTML = method.details.map((item, index) => `
        <li class="price-v11__price-item${index === 0 && firstIsOld ? ' price-v11__price-item--old' : ''}">
          ${item.title} <span>${item.description}</span>
        </li>
      `).join('')
      priceInfo.hidden = false
    } else {
      priceInfo.hidden = true
      priceList.innerHTML = ''
    }

    priceValueEl.hidden = false
    priceValue.textContent = method.paymentsCount
      ? `${method.paymentsCount} х ${method.totalPrice}`
      : method.totalPrice

    if (priceDescriptions) {
      if (method.descriptions?.length) {
        priceDescriptions.innerHTML = method.descriptions.map(desc => `<li>${desc}</li>`).join('')
        priceDescriptions.hidden = false
      } else {
        priceDescriptions.innerHTML = ''
        priceDescriptions.hidden = true
      }
    }
  }

  const handleButtonMobileClick = (evt) => {
    evt.preventDefault()
    evt.stopPropagation()

    const modal = showContactsMobileModal({
      blockName,
      paymentPrice: selectPaymentType.dataset.paymentPrice,
      paymentType: selectPaymentType.dataset.paymentType,
      hiddenFields: [
        { name: 'payment_type', value: selectPaymentType.value },
        { name: 'nomenclature_id', value: String(nomenclatureId) },
        { name: 'block', value: 'autopayment' },
        { name: 'country_code', value: form.country_code.value },
        { name: 'type', value: 'lead' },
        { name: 'landing_id', value: form.landing_id.value }
      ],
    })

    modal?.form.addEventListener('form-success', () => {
      if (selectPaymentType.value === 'cloudpayments') {
        modal.close()
      }

      form?.parentElement.classList.add('js-success')
    })
  }

  form.nomenclature_id.value = nomenclatureId

  let selectPaymentType = form.querySelector('.extended-autopayment-method__input:checked')

  if (!selectPaymentType) {
    const error = new Error(`[PriceV11]: .extended-autopayment-method__input not found`)
    window.Sentry?.captureException(error)
    return
  }

  selectPaymentType.checked = true
  let selectMethod = selectPaymentType.closest('.extended-autopayment-method')

  const desktop = window.matchMedia(`(min-width: ${Media.LG}px)`)

  const setDetailsHeight = (height = null) => {
    const detailsList = selectMethod.querySelector('.extended-autopayment-method__list')
    const detailsButtonWrapper = selectMethod.querySelector('.extended-autopayment-method__button-wrapper')

    if (detailsList) {
      detailsList.style.height = height !== null ? `${height}px` : `${detailsList.scrollHeight}px`
      detailsList.style.marginTop = height === 0 ? '0px' : '20px'
    }

    if (detailsButtonWrapper) {
      if (height !== null) {
        detailsButtonWrapper.style.height = `${height}px`
      } else {
        let wrapperHeight = detailsButtonWrapper.scrollHeight
        if (!wrapperHeight) {
          detailsButtonWrapper.style.height = 'auto'
          wrapperHeight = detailsButtonWrapper.scrollHeight
        }
        detailsButtonWrapper.style.height = `${wrapperHeight}px`
      }
    }
  }

  const setButtonContent = () => {
    const paymentPrice = selectPaymentType.dataset.paymentPrice

    submitButtonDesktop.classList.toggle('price-v11__button--with-price', !!paymentPrice)
    submitButtonDesktop.querySelector('.ui-button__text').innerHTML = `
      <span class="f f--16 f--m">${selectPaymentType.dataset.paymentType}</span>
      ${paymentPrice ? `<span class="f f--12">${paymentPrice}</span>` : ''}`
  }

  const toggleContactsInputs = (disabled) => {
    contactsInputs.forEach(input => { input.disabled = disabled })
  }

  const desktopMediaChangeListener = () => {
    isDesktop = desktop.matches

    if (isDesktop) {
      toggleContactsInputs(false)
    } else {
      toggleContactsInputs(true)
      setDetailsHeight()
    }
  }

  desktopMediaChangeListener()
  setButtonContent()
  setPriceInfo(findMethod(selectPaymentType.value))

  desktop.addEventListener('change', desktopMediaChangeListener)

  methodsWrapper?.addEventListener('change', (evt) => {
    if (!isDesktop) {
      selectMethod.classList.remove('js-error', 'js-success')

      setDetailsHeight(0)
    }

    selectPaymentType = evt.target
    selectMethod = evt.target.closest('.extended-autopayment-method')

    if (!isDesktop) {
      setDetailsHeight()
    }

    setButtonContent()
    setPriceInfo(findMethod(selectPaymentType.value))

    window.$analytics?.push('price-type-click', {
      action: `Select ${evt.target.dataset.analytics}`,
      blockName
    })
  })

  helpPhoneLink?.addEventListener('click', () => {
    window.$analytics?.push('phone-link-click', { blockName })
  })

  submitButtonMobile.forEach(button => button.addEventListener('click', (evt) => handleButtonMobileClick(evt)))

  form.addEventListener('form-sended', (evt) => {
    window.$analytics?.push('price-form-send', {
      requestId: evt.sendingResult?.formData.get('request_id'),
      label: evt.sendingResult?.formData.get('payment_type'),
      blockName,
      promo_accepted: Number(promoAccepted?.checked)
    })
  })
}()
